module.exports = __webpack_public_path__ + "media/svg-new/monster-2-9eb8a1d9.svg";